export class FleetManagementApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Create a fleet organization (starts in `onboarding`). */
    createOrganization(input) {
        return this.client.request({ method: 'POST', path: '/v1/fleet/organizations', body: input, auth: true });
    }
    /** Advance an organization's lifecycle (`onboarding → active → suspended → closed`). */
    transitionOrganization(organizationId, to) {
        return this.client.request({ method: 'POST', path: `/v1/fleet/organizations/${encodeURIComponent(organizationId)}/transition`, body: { to }, auth: true });
    }
    /** Read one organization + its current version. */
    getOrganization(organizationId) {
        return this.client.request({ method: 'GET', path: `/v1/fleet/organizations/${encodeURIComponent(organizationId)}`, auth: true });
    }
    /** List every fleet organization, newest first (operator `fleet:view`, filtered to the caller's fleets; admin oversight). */
    listOrganizations() {
        return this.client.request({ method: 'GET', path: '/v1/fleet/organizations', auth: true });
    }
    /** Register a vehicle asset under an organization (starts in `registered`). */
    registerAsset(organizationId, input) {
        return this.client.request({ method: 'POST', path: `/v1/fleet/organizations/${encodeURIComponent(organizationId)}/assets`, body: input, auth: true });
    }
    /** Advance an asset's lifecycle (`registered → active → maintenance → retired`; reaching active is document-gated). */
    transitionAsset(assetId, to) {
        return this.client.request({ method: 'POST', path: `/v1/fleet/assets/${encodeURIComponent(assetId)}/transition`, body: { to }, auth: true });
    }
    /**
     * D850 (L4-009): the document types the fleet's market requires of a vehicle (the governed required-documents catalog).
     * `known: false` when the requirement cannot be stated (no market, no catalog in force).
     */
    requiredDocuments(organizationId) {
        return this.client.request({ method: 'GET', path: `/v1/fleet/organizations/${encodeURIComponent(organizationId)}/required-documents`, auth: true });
    }
    /** List an organization's vehicle assets (newest first). */
    listAssets(organizationId) {
        return this.client.request({ method: 'GET', path: `/v1/fleet/organizations/${encodeURIComponent(organizationId)}/assets`, auth: true });
    }
    /** Attach a driver to an organization as a scoped role grant (a reference, never an embedded identity). */
    attachDriver(organizationId, input) {
        return this.client.request({ method: 'POST', path: `/v1/fleet/organizations/${encodeURIComponent(organizationId)}/drivers`, body: input, auth: true });
    }
    /** Assign an asset to a driver (via the driver's grant) — only the asset's driver pointer is set. */
    assignAsset(assetId, grantId) {
        return this.client.request({ method: 'POST', path: `/v1/fleet/assets/${encodeURIComponent(assetId)}/assign`, body: { grantId }, auth: true });
    }
    /** Create an effective-dated organization↔counterparty contract. */
    createContract(input) {
        return this.client.request({ method: 'POST', path: '/v1/fleet/contracts', body: input, auth: true });
    }
    /** Read one grant + whether it has been soft-revoked. */
    getGrant(grantId) {
        return this.client.request({ method: 'GET', path: `/v1/fleet/grants/${encodeURIComponent(grantId)}`, auth: true });
    }
    /** Detach (soft-revoke) a grant. */
    revokeGrant(grantId) {
        return this.client.request({ method: 'POST', path: `/v1/fleet/grants/${encodeURIComponent(grantId)}/revoke`, body: {}, auth: true });
    }
}
//# sourceMappingURL=fleet-management.js.map